import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as $9gyGR$useState } from "react";
import { useLayoutEffect as $9gyGR$useLayoutEffect } from "@radix-ui/react-use-layout-effect";

function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
  var _$9gyGR$useState = $9gyGR$useState(undefined),
      _$9gyGR$useState2 = _slicedToArray(_$9gyGR$useState, 2),
      size = _$9gyGR$useState2[0],
      setSize = _$9gyGR$useState2[1];

  $9gyGR$useLayoutEffect(function () {
    if (element) {
      // provide size as early as possible
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      var resizeObserver = new ResizeObserver(function (entries) {
        if (!Array.isArray(entries)) return; // Since we only observe the one element, we don't need to loop over the
        // array

        if (!entries.length) return;
        var entry = entries[0];
        var width;
        var height;

        if ('borderBoxSize' in entry) {
          var borderSizeEntry = entry['borderBoxSize']; // iron out differences between browsers

          var borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize['inlineSize'];
          height = borderSize['blockSize'];
        } else {
          // for browsers that don't support `borderBoxSize`
          // we calculate it ourselves to get the correct border box.
          width = element.offsetWidth;
          height = element.offsetHeight;
        }

        setSize({
          width: width,
          height: height
        });
      });
      resizeObserver.observe(element, {
        box: 'border-box'
      });
      return function () {
        return resizeObserver.unobserve(element);
      };
    } else // We only want to reset to `undefined` when the element becomes `null`,
      // not if it changes to another element.
      setSize(undefined);
  }, [element]);
  return size;
}

export { $db6c3485150b8e66$export$1ab7ae714698c4b8 as useSize };